module.exports = __webpack_public_path__ + "static/media/high-vis-vest.a2a9b321.jpg";